// ============================================
// FILE: /frontend/src/components/layout/DashboardLayout.jsx
// PURPOSE: Dashboard layout wrapper with navigation
// ============================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from './Header';
import { useAuth } from '../../hooks/useAuth';

export default function DashboardLayout({ children }) {
  console.log('[DashboardLayout] Rendering');
  
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Main Header with hamburger menu */}
      <Header />

      {/* Main Content */}
      <main className="container mx-auto px-4 py-6 sm:py-8">
        {/* Welcome Section */}
        <div className="bg-white rounded-lg border border-border p-3 sm:p-4 mb-4 sm:mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/10 flex items-center justify-center text-base sm:text-lg font-semibold text-primary">
                {user?.fullName?.charAt(0).toUpperCase() || 'U'}
              </div>
              <div>
                <h2 className="text-sm sm:text-base md:text-lg font-semibold">
                  Welcome back{user?.fullName ? `, ${user.fullName}` : ''}!
                </h2>
                <p className="text-xs sm:text-sm text-muted-foreground">{user?.email}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Page Content */}
        {children}
      </main>

      {/* Dashboard Footer */}
      <footer className="bg-white border-t mt-auto">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
            <p>© 2025 MotoHome Finder. All rights reserved.</p>
            <div className="flex gap-4">
              <Link to="/help" className="hover:text-foreground transition">
                Help Center
              </Link>
              <Link to="/privacy" className="hover:text-foreground transition">
                Privacy
              </Link>
              <Link to="/terms" className="hover:text-foreground transition">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}